export enum PageConfigTypes {
  GLOBAL = "GLOBAL",
  REGISTER = "REGISTER",
  DASHBOARD = "DASHBOARD",
  JOBS = "JOBS",
  HOME = "HOME",
  STATIC_PAGE = 'STATIC_PAGE',
  REGISTER_INTEREST = 'REGISTER_INTEREST',
  NAV = "NAV",
  FOOTER = "FOOTER"
}

export interface GlobalConfig {
  collectFullAddress?: boolean;
  disablePortalVerification?: boolean;
  disableResumeRegistration?: boolean;
  enableAvailability?: boolean;
  defaultFontFamily?: string;
  enableHomePage?: boolean;
  enableAboutSections?: boolean;
  heroImageMaxWidth?: string;
  useThemeGlow?: boolean;
  enableTalentCta?: boolean;
  enableTalentVideo?: boolean;
  enableReviewDetails?: boolean;
  enableSkills?: boolean;
  enableSuggestions?: boolean;
  hideClient?: boolean;
  requireAvailability?: boolean;
  requireResume?: boolean;
  requireSkills?: boolean;
  googleTagManagerId?: string;
  logoSize?: string;
  footerSize?: string;
  customizeDoneMessage?: boolean;
  doneMessageTitle?: string;
  doneMessageBody?: string;
  hideResumeUploadStep?: boolean;
  enableInviteMessage?: boolean;
  referFriends?: boolean;
  inviteMessageTitle?: string;
  inviteMessageBody?: string;
  showBanner?: boolean;
  bannerText?: string;
  navBackgroundColor?: string;
  navTextColor?: string;
  navActiveTextColor?: string;
  footerBackgroundColor?: string;
  footerTextColor?: string;
  footerLinkColor?: string;
  footerCookiesText?: string;
  footerCopyrightText?: string;
}

export interface UpdateConfigRes {
  template: { _id: string };
  theme: { _id: string };
  fontFamily: string;
  configuration: GlobalConfig;
}
export interface ConfigQuestion {
  type: string;
  key: string;
  question: string;
  visibleWhen?: {
    key: string;
    value: string | number | boolean;
  };
  actionLabel?: string;
  actionData?: {
    titleKey: string;
    bodyKey: string;
    defaultTitle?: string;
    defaultBody?: string;
  };
}

export interface ThemeAndTemplateResponse {
  themes: ThemeResponse;
  templates: TemplateResponse;
}

export interface TemplateResponse {
  portaltemplates: Theme[];
  total: number;
}

export interface ThemeResponse {
  portalthemes: Theme[];
  total: number;
}

export interface Theme {
  colors?: ThemeColors;
  _id: string;
  name: string;
  value?: string;
}

export interface SelectOption {
  name: string;
  id?: string;
  value?: string;
}

export interface ThemeColors {
  accentColor: string;
  primaryColor: string;
  warnColor: string;
}
